<template>
  <div class="collectingResources">
    <v-publiceTit :titleObj='titleObj'></v-publiceTit>
    <div class="collectingCon clearfix">
      <div class="tableLeft col-lg-4 col-md-4 col-sm-12 col-xs-12">
        <h4>复星战略协议</h4>
        <span class="titleTwo">已上线 {{protocolInfo.protocolNumber}} 份协议</span>
        <p>这里有复星集团最优质的供应商资源，以及具有竞争力的战略价格。若查看协议内容及价格请进入“<a href="#" @click="jumpProtocol()">复星战略协议</a>”模块或点击查看更多协议。</p>
        <button type="button" class="btn btn-default btn-lg" @click="jumpProtocol()">MORE</button>
      </div>
      <!--<div class="tableLeft hidden-md hidden-lg">-->
        <!--<h4>复星战略协议</h4>-->
        <!--<span class="titleTwo">已上线  {{protocolInfo.protocolNumber}} 份协议</span>-->
        <!--<p>这里有复星集团最优质的供应商资源，以及具有竞争力的战略价格。若查看协议内容及价格请进入“复星战略协议”模块或点击查看更多协议。</p>-->
        <!--<button type="button" class="btn btn-default btn-lg">MORE</button>-->
      <!--</div>-->
      <div class="tableRight col-lg-8 col-md-8 col-sm-12 col-xs-12 pull-right">
        <div class="tableCom">
          <div class="tableTitle" >
            <span class="col-lg-3 col-md-3 col-xs-4 col-sm-4">供应品类</span>
            <span class="col-lg-3 col-md-3 col-xs-4 col-sm-4">品牌名称</span>
            <span class="col-lg-6 col-md-6 col-xs-4 col-sm-4">协议名称</span>
          </div>
          <div class="tableCon">
            <p class="tableTr clearfix" v-for="(protocol,index) in protocolInfo.protocolList" :key="index">
              <span class="col-lg-3 col-md-3 col-xs-4 col-sm-4">{{protocol.supplyCategory}}</span>
              <span class="col-lg-3 col-md-3 col-xs-4 col-sm-4">{{protocol.brandName}}</span>
              <span class="col-lg-6 col-md-6 col-xs-4 col-sm-4" @click="jump(viewProtocolDetailUrl,protocol.id)"><a>{{protocol.protocolName}}<i class="newIcon"  v-if="protocol.newFlag"></i></a></span>
            </p>
            <!--<i class="newIcon"></i> 是new图标   手机端显示  pc端没有  手机端需要判断什么时候显示-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import publiceTit from '@/components/publiceTit'
import { mapState } from 'vuex'
export default {
  props: ['protocolInfo','viewProtocolDetailUrl'],
  data () {
    return {
      titleObj: {name: '集采资源', eng: 'Collection resources'},
      userInfo:{}
    }
  },
  components: {
    'v-publiceTit': publiceTit
  },
  created () {
    if(this.getToken('isLogin') !=''){
     this.userInfo = JSON.parse(this.getDAesString(this.getToken('userInfo'),this.KP.key,this.KP.iv));
    }
  },
  computed: mapState([
    'KP'
  ]),
  methods: {
    jump(viewProtocolDetailUrl,id){
      if(this.getToken('isLogin') == ''){
        this.$router.push({path:'/login',query:{redirectURL:'/protocol'}});
      }else if(this.getToken('examineStatus') == '200'){
        this.$router.push({path:"registerExamine",query:{email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,trueName:this.userInfo.trueName}});
      }else if(this.getToken('examineStatus') == '300'){
        this.$router.push({path:"registerFailed",query:{userId:this.userInfo.id,email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,regeisterType:this.getToken('regeisterType'),exmaineMessage:this.getToken('exmaineMessage'),createUserId:this.userInfo.createUserId}});
      }
      else if(this.getCookie("COMPANY_COMPLETE_STATUS_"+this.getCookie("justId")) == "1"){
        this.$alert('<p>企业变更信息已提交，请耐心等待审核结果</p>', '', {
            dangerouslyUseHTMLString: true,
            customClass:'mobileText',
            center: true,
            showClose:false
          });
      }
      else if(this.getToken('checkFlag') == 200 && this.getCookie('TALK_LATER_'+this.getCookie('justId'))>=14){
//        this.$alert('请立即完善企业信息', '您的企业信息不完整，无法进入项目。', {
//          confirmButtonText: '立即完善企业信息',
//          center: true,
//          showClose:false,
//          callback: action => {
//            this.$router.push({path:'/inforPerfection'});
//          }
//        });
        if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
          this.$alert('<p>请登录pc端完善企业信息</p>', '', {
            dangerouslyUseHTMLString: true,
            customClass:'mobileText',
            center: true,
            showClose:false
          });
        }else{
          this.$confirm('请立即完善企业信息', '您的企业信息不完整，无法进入项目。', {
            cancelButtonClass:'cancelBtn',
            customClass:'mobileText',
            cancelButtonText: '以后再说',
            confirmButtonText: '点我补全',
            center: true
          }).then(() => {
            this.$router.push({path:'/inforPerfection'});
          }).catch(() => {
              this.$axios.post('/onelink.mdata.main.api/web/operateTalkLater', {
              }).then((res) => {
                this.data = res.data;
                this.removeCookie('TALK_LATER_'+this.data.userId);
                this.setCookie('TALK_LATER_'+this.data.userId,this.data.instanceDay);
              });
          });
        }
      }
      else{
        this.userInfo = JSON.parse(this.getDAesString(this.getToken('userInfo'),this.KP.key,this.KP.iv));
        this.companyInfo = JSON.parse(this.getDAesString(this.getToken('companyInfo'),this.KP.key,this.KP.iv));
        this.$axios.post('/onelink.mdata.main.api/recruitInfo/checkHasViewDataAuth?userId='+this.userInfo.id+"&currentOrgId="+this.companyInfo.orgId, {
        }).then((res) => {
          this.loading=false;
          this.data = res.data;
          if(this.data){
            // let newWin = window.open("about:blank",'查看采购协议','width='+ (window.screen.availWidth-10)+',height='+(window.screen.availHeight-30)+ ',top=0,left=0,resizable=yes,status=yes,menubar=no,scrollbars=yes');
            // newWin.location.href=viewProtocolDetailUrl + id;
            let routeData = this.$router.resolve({ path: '/recruit', query: {  redirctUtl: viewProtocolDetailUrl + id } });
            window.open(routeData.href, '查看协议信息');
          }else{
//            this.$alert('很抱歉，您没有访问权限…', '', {
//            });
            this.$alert('<p>很抱歉，您没有访问权限…</p>', '', {
              dangerouslyUseHTMLString: true,
              customClass:'mobileText',
              center: true
            });
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    
    jumpProtocol(){
      this.$router.push({path:'/protocol'});
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/collectingResources/index.vue